import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useDraftItemsStyles = makeStyles((theme: Theme) =>
  createStyles({
    dateBlockMobile: {
      display: 'grid',
      gridTemplateColumns: '40px minmax(0, 1fr) 72px',
      alignItems: 'end',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    mobileFilterControl: {
      width: 40,
    },
    mobileSortSelect: {
      minWidth: '0 !important',
      width: '100%',
      '& label': {
        display: 'none',
      },
      '& .MuiOutlinedInput-root': {
        minHeight: 40,
      },
      '& .MuiSelect-select': {
        minHeight: 40,
        padding: theme.spacing(0, 1),
        paddingRight: theme.spacing(3),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    mobileShowItemsSelect: {
      width: 72,
      minWidth: '0 !important',
      '& label': {
        display: 'none',
      },
      '& .MuiOutlinedInput-root': {
        minHeight: 40,
      },
      '& .MuiSelect-select': {
        minHeight: 40,
        padding: theme.spacing(0, 1),
        paddingRight: theme.spacing(3),
      },
    },
    queryParamsHolder: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    filterContainer: {
      marginTop: 71,
      position: 'relative',
      zIndex: 999,
      [theme.breakpoints.down('sm')]: {
        maxWidth: 90,
      },
    },
  })
)
